import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import helpers from 'helpers';
import FilterBar from 'components/atoms/tables/FilterBar';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import RenderingTile from 'components/molecules/RenderingTile';
import DemographicsPivotTable from 'components/molecules/tables/DemographicsPivotTable';

const RadioWrapper = styled.div`
    label{
        margin: 5px 5px 5px;
        font-weight: normal;
        font-size: 12px;
    }
    input{
        margin: 0px 5px;
    }
`;

class ToggleDemographicsPivotTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pivotBy: this.props.pivotBy
        };
    }

    handleRadioChange = (event) => {
        this.setState({
            ...this.state,
            pivotBy: [event.target.value]
        });
    }

    render() {
        const { hasDemographicsData, demographicsData, exportName } = this.props;
        return hasDemographicsData ? (
            <ContentTile padding={helpers.contentPadding('table')}>
                <ContentHeader tableData={demographicsData} exportName={exportName} type={'table'}>FACEBOOK DEMOGRAPHIC OVERVIEW</ContentHeader>
                <FilterBar>
                    <RadioWrapper>
                        <label>
                            <input
                                type='radio'
                                value='age'
                                checked={this.state.pivotBy[0] === 'age'}
                                onChange={this.handleRadioChange}
                            />
                                AGE
                        </label>
                        <label>
                            <input
                                type='radio'
                                value='gender'
                                checked={this.state.pivotBy[0] === 'gender'}
                                onChange={this.handleRadioChange}
                            />
                                GENDER
                        </label>
                    </RadioWrapper>
                </FilterBar>
                <DemographicsPivotTable
                    {...this.props}
                    pivotBy={this.state.pivotBy}
                />
            </ContentTile>
        ) : (
            <RenderingTile height='400px' show={hasDemographicsData} />
        );
    }
}

ToggleDemographicsPivotTable.propTypes = {
    pivotBy: PropTypes.arrayOf(PropTypes.string),
    hasDemographicsData: PropTypes.bool.isRequired
};

export default ToggleDemographicsPivotTable;



// WEBPACK FOOTER //
// ./src/components/organisms/ToggleDemographicsPivotTable.js